@use "../../styles/breakpoint.module.scss" as *;

.rootTwo {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    .inner {
        grid-column: 2 / span 10;

        @media ($below-mobile) {
            grid-column: 1 / -1;
        }
    }
}

.rootThree {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;
    justify-content: center;

    .inner {
        width: 75%;

        @media ($below-mobile) {
            width: 100%;
        }
    }
}

.inner {
    --col-gap: var(--spacer-40);

    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--spacer-48) var(--col-gap);
}

.item {
    flex: 0 0 var(--basis);
}

.itemTwo {
    composes: item;

    --basis: calc(50% - var(--col-gap) / 2);

    @media ($below-mobile) {
        --basis: 100%;

        padding-inline: var(--spacer-120);
    }
}

.itemThree {
    composes: item;

    --basis: calc(32.5% - var(--col-gap) / 2);

    @media ($below-mobile) {
        --basis: calc(40% - var(--col-gap) / 2);
    }

    @media ($below-tiny) {
        --basis: calc(50% - var(--col-gap) / 2);
    }
}

.picture {
    display: block;
    margin-bottom: var(--spacer-16);
}

.richText {
    :global(.eyebrow) {
        margin-bottom: var(--spacer-8);
    }

    p {
        margin-block: var(--spacer-8);
    }
}
